import {  ThemeOptions } from "@mui/material";
import { createTheme } from '@mui/material/styles'

const theme: ThemeOptions = createTheme({
    palette: {
        primary: {
            main: "#67C090"
        }
    }
})

export default theme
